import { useApi } from "@/lib/api";
import { MeasurementsView } from "@/types/measurements";

export function useMeasurements(periodId: string | null) {
  return useApi<MeasurementsView>(
    periodId ? `/api/utility/measurements/${periodId}` : null,
    [periodId],
  );
}
